import { InfoCircleFilled } from '@ant-design/icons';
import { Row } from 'antd';

import { commonStore } from 'stores';
import { useGetRequest } from 'hooks';

import { OverviewResponse } from 'codegen';

export const RICEInfo = () => {
  const user = commonStore((state) => state.user);
  const isSessionExpired = commonStore((state) => state.isSessionExpired);

  const { data, loading } = useGetRequest<OverviewResponse>({
    url: '/overview/rice',
    options: {
      ready: !!user && !isSessionExpired,
      pollingInterval: 60000, // 1 minute
    },
  });

  if (!user || data?.isRiceAvailable || loading) {
    return null;
  }

  return (
    <Row align='middle' className='min-h-[40px] px-8 bg-[#fffbe6] border-1  border-solid border-[#fff2bd]'>

      <InfoCircleFilled className='text-[#faad14] mr-2' />

      RICE is on maintenance right now. Currently issuance functionality is unavailable.
    </Row>
  );
};
